import { useTheme } from "@emotion/react";
import { Box, Button, Grid, List, TextField, Typography, Stack } from "@mui/material";
import Skeleton from '@mui/material/Skeleton';
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Empty from "../../../components/Empty";
import { jobActions } from "../../../redux/reducers/job-slice";
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import InfoIcon from '@mui/icons-material/Info';
import ModalBox from "../../../components/ModalBox";
import useAxiosPrivate from "../../../hooks/use-axios-private";
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import ReactCompareImage from 'react-compare-image'
import { APP_CURRENCY } from "../../../constants";


const SelectServiceStep = ({ enableNext }) => {
    const theme = useTheme()
    const dispatch = useDispatch()
    const jobName = useSelector(state => state.job.title)
    const selectedService = useSelector(state => state.job.service[0])
    const [serviceList, setserviceList] = useState(false)
    const [selectedServiceType, setSelectedServiceType] = useState(null)
    const axios = useAxiosPrivate()
    const [open, setOpen] = useState(false)
    const [serviceTypes, setServiceTypes] = useState([])
    const [serviceinfo, setServiceinfo] = useState({
        before_image: {},
        after_image: {}
    });

    const handlePackageClick = (service) => {
        dispatch(jobActions.updateService(service))
    }

    useEffect(() => {
        const getServicesList = async () => {
            try {
                setserviceList(false)
                let resp = await axios.get('services/', { params: { limit: 0, categories: 1, file_type: selectedServiceType } });
                setServiceTypes(resp.data.data.service_category_list)
                setSelectedServiceType(prev => {
                    if (prev === null) {
                        return resp.data.data.service_category_list[0].category_id
                    }
                    return prev
                })
                setserviceList(resp.data.data.service)
                if (selectedService) {
                    const updatedService = resp.data.data.service.find(ele => ele.id === selectedService?.id)
                    updatedService && dispatch(jobActions.updateJob({ service: [updatedService] }))
                }
            }
            catch (err) {
                console.error(err)
            }
        }
        getServicesList()
    }, [selectedServiceType])

    useEffect(() => {
        enableNext(true)
    }, [enableNext])

    useEffect(() => {
        setSelectedServiceType(selectedService?.file_type || null)
    }, [selectedService])

    return (
        <Box sx={{ pt: { xs: 4, sm: 2, md: 0 } }}>
            <Grid item xs={12} sm={8} md={6} lg={4} sx={{ mb: { xs: 2, sm: 3, md: 2, lg: 4 } }}>
                <TextField fullWidth size='medium' label="Job title" value={jobName} name="job_title" onChange={(e) => dispatch(jobActions.updateJobName(e.target.value))} autoComplete='off' />
            </Grid>
            <Stack spacing={{ xs: 3, sm: 2 }} direction="row" useFlexGap flexWrap="wrap" sx={{ pb: { xs: 3, md: 1, lg: 2.5 } }}>
                {
                    serviceTypes.map((category, index) => (
                        <Box key={index}>
                            <Button
                                onClick={() => {
                                    setSelectedServiceType(category.category_id)
                                }}
                                sx={{
                                    fontSize: "16px",
                                    textAlign: "center",
                                    textTransform: "capitalize",
                                    borderRadius: "28px",
                                    padding: "8px 20px",
                                    color: theme.palette.mode === "dark" ? theme.palette.background.stripped : "#000",
                                    border: category.category_id === selectedServiceType ? "1px solid #f764a3" : "1px solid #d1d1d1",
                                    background: category.category_id === selectedServiceType ? '#f764a32e' : 'transparent',
                                    '&:hover': {
                                        background: '#f764a32e',
                                        color: "#0b1345",
                                        border: "1px solid #f764a3"
                                    },
                                    ...(category.category_id === selectedServiceType ? { color: "#0b1345" } : {})
                                }}>
                                {category.category_name}
                            </Button>
                        </Box>
                    ))
                }
            </Stack>
            <Box sx={{ height: { xs: "100%", sm: "40vh", md: "25vh", xl: "35vh" }, overflowY: "auto", pl: 1, pr: 2, pt: 2, pb: 1 }} className="overflow-scroll">
                <Grid container spacing={{ xs: 2, md: 3 }} alignItems="stretch">
                    {
                        (
                            serviceList === false
                                ?
                                [1, 2, 3, 4, 5, 6].map((index) => (
                                    <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                                        <List component="nav" aria-label="main mailbox folders" sx={{ px: 2, border: "3px solid #e2e2e2", borderRadius: 5, cursor: "pointer" }}>
                                            <Skeleton animation="wave" sx={{ p: 4, borderRadius: 2 }} />
                                        </List>
                                    </Grid>
                                ))
                                :
                                (
                                    serviceList.length > 0
                                        ?
                                        serviceList.map((service, index) => (
                                            <Grid item xs={12} sm={6} lg={4} xl={3} key={index} sx={{ display: 'flex', flexDirection: "column" }}>
                                                <Box className='selectService' sx={{ backgroundColor: "#fff", postion: 'relative', cursor: 'pointer', borderRadius: 3, transition: "0.4s", height: '100%', border: `${service.id === selectedService?.id ? "2px solid #f764a3" : "2px solid #fff"}`, transform: `${service.id === selectedService?.id ? "scale(1)" : "scale(1)"}`, '::after': { backgroundColor: `${service.id === selectedService?.id ? "#f764a3" : "#0b13451c"}` }, p: "4px", pl: 2, boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px" }} onClick={() => handlePackageClick(service)} >
                                                    <Box sx={{ display: "flex", borderRadius: "6px", justifyContent: 'space-between', alignItems: "center", p: 1.5, paddingBottom: "10px", }}>

                                                        <Box>
                                                            <Box sx={{ pt: 0 }}>
                                                                <Typography sx={{ fontSize: "16px", fontWeight: 500, color: theme.palette.primary.main }}>{service.name}</Typography>
                                                            </Box>
                                                            <Box>
                                                                <Typography color={"text.secondary"} sx={{ fontSize: "14px", fontWeight: 500, }}>{APP_CURRENCY.currency_symbol} {service.price}</Typography>
                                                            </Box>
                                                        </Box>
                                                        <Box >
                                                            <InfoIcon
                                                                onClick={(e) => {
                                                                    e.stopPropagation()
                                                                    setOpen(true)
                                                                    setServiceinfo(service)
                                                                }}
                                                                sx={{ color: `${service.id === selectedService?.id ? "#f764a3" : '#9e9e9e'}`, fontSize: "24px", cursor: "pointer", p: 1, background: `${service.id === selectedService?.id ? "#f764a32e" : '#9e9e9e14'}`, borderRadius: 50 }}></InfoIcon>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Grid>
                                        ))
                                        :
                                        <Grid item xs={12}>
                                            <Empty icon={<SettingsOutlinedIcon sx={{ fontSize: 40, color: "grey", }} />} text="No services available" />
                                        </Grid>
                                )
                        )

                    }
                </Grid>
            </Box>
            <ModalBox
                open={open}
                onClose={() => { setOpen(false) }} >
                <Box sx={{ mb: 2 }}>
                    <Typography sx={{ color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main, fontSize: { xs: 20, xl: 22 }, fontWeight: '400' }}>{serviceinfo.name}</Typography>
                </Box>
                <Box sx={{ mb: 3 }}>
                    <Typography sx={{ color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : "comman.black" }}>{serviceinfo.description}</Typography>
                </Box>

                <Box className="service-compare-img">
                    {
                        serviceinfo.before_image.url && serviceinfo.after_image.url
                            ?
                            <ReactCompareImage leftImage={serviceinfo.before_image.url} rightImage={serviceinfo.after_image.url} />
                            :
                            <Empty icon={<ImageOutlinedIcon sx={{ fontSize: 60, color: "grey" }} />} text="No preview image available" />
                    }
                </Box>

                <Box sx={{ mt: 4, textAlign: "right" }}>

                    <Button
                        variant="outlined"
                        color="primary"
                        sx={{ ml: 2 }}
                        onClick={() => setOpen(false)}
                    >
                        Cancel
                    </Button>
                </Box>
            </ModalBox>

        </Box>
    )
}
export default SelectServiceStep
